module.exports = __webpack_public_path__ + "static_pc/img/1.fb1fdf1b.png";